import React, { useState } from 'react'
import Pagination from 'react-js-pagination';
import { dateFormatWithTime } from 'utils/dateFormat';
import { charLimit } from 'utils/formValidator';
import { FaBell } from "react-icons/fa";
import NotFound from 'common/NotFound';
import useFullPageLoader from 'common/UseFullPageLoader';
import { CustomModal } from 'components/modals/ModalBox';

const NotificationList = ({ loader, onHide, notificationList, activePage, total, setSearchParams, searchParams }) => {

    const [descriptionModal, setDescriptionModal] = useState({ title: '', status: false });
    const [description, setDescription] = useState("");

    //-------------handle-Page-Change-----------------
    const handlePageChange = (event) => {
        searchParams.set("page", event);
        setSearchParams(searchParams);
    };
    //---------handle-Close-Modal-----------
    const handleCloseModal = () => {
        setDescriptionModal({ title: '', status: false })
        setDescription('')
    }
    return (
        <div className="student_management">
            {loader}
            <div className="card">
                <div className="card-body">
                    <div className="table_wrap ">
                        <table className="table custom_table">
                            <thead>
                                <tr>
                                    <th className="nowrap">S.no</th>
                                    <th className="nowrap">Title</th>
                                    <th className="nowrap">Message</th>
                                    {/* <th className="nowrap">Total Send</th> */}
                                    <th className="nowrap">Type</th>
                                    <th className="nowrap">Created At</th>
                                    {/* <th className="nowrap text-center">Action</th> */}
                                </tr>
                            </thead>
                            <tbody>

                                {notificationList && notificationList?.length > 0 ? (
                                    notificationList?.map((data, index) => {
                                        return (
                                            <tr key={++index}>
                                                <td className="nowrap">{++index + (activePage - 1) * 10}</td>
                                                <td className="nowrap">
                                                    {/* {data?.title || "N/A"} */}
                                                    {data?.title?.length > 20 ? (
                                                        <div className="d-flex wrap_td_span">
                                                            <p
                                                                dangerouslySetInnerHTML={{
                                                                    __html: charLimit(data?.title, 20),
                                                                }}
                                                            ></p>
                                                            &nbsp;
                                                            <span
                                                                onClick={() => {
                                                                    setDescriptionModal({ title: 'Title', status: true });
                                                                    setDescription(
                                                                        <p
                                                                            dangerouslySetInnerHTML={{
                                                                                __html: data?.title,
                                                                            }}
                                                                        ></p>
                                                                    );
                                                                }}
                                                            >
                                                                <b>Read More</b>
                                                            </span>
                                                        </div>
                                                    ) : (
                                                        <p
                                                            dangerouslySetInnerHTML={{
                                                                __html: data?.title,
                                                            }}
                                                        ></p>
                                                    )}

                                                </td>
                                                <td className="nowrap">
                                                    {data?.message?.length > 20 ? (
                                                        <div className="d-flex wrap_td_span">
                                                            <p
                                                                dangerouslySetInnerHTML={{
                                                                    __html: charLimit(data?.message, 20),
                                                                }}
                                                            ></p>
                                                            &nbsp;
                                                            <span
                                                                onClick={() => {
                                                                    setDescriptionModal({ title: 'Message', status: true });
                                                                    setDescription(
                                                                        <p
                                                                            dangerouslySetInnerHTML={{
                                                                                __html: data?.message,
                                                                            }}
                                                                        ></p>
                                                                    );
                                                                }}
                                                            >
                                                                <b>Read More</b>
                                                            </span>
                                                        </div>
                                                    ) : (
                                                        <p
                                                            dangerouslySetInnerHTML={{
                                                                __html: data?.message,
                                                            }}
                                                        ></p>
                                                    )}
                                                </td>
                                                {/* <td>{data?.totalSend || "0"}</td> */}
                                                <td>{data?.isSchedule ? 'Schedule' : 'Normal'}</td>
                                                <td>{dateFormatWithTime(data?.createdAt)}</td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <NotFound
                                        cols={7}
                                        msg={"Notification not found"}
                                        onHide={onHide}
                                        icon={<FaBell />}
                                    />
                                )}
                            </tbody>
                        </table>
                    </div>
                    {total > 10 && (
                        <div className="pagination-wrapper">
                            <div className="Pagination">
                                <Pagination
                                    activePage={activePage}
                                    previousLabel={"previous"}
                                    nextLabel={"next"}
                                    itemsCountPerPage={10}
                                    totalItemsCount={total}
                                    pageRangeDisplayed={5}
                                    onChange={handlePageChange}
                                    hideDisabled={true}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {descriptionModal?.status && (
                <CustomModal
                    className={"add_model"}
                    show={descriptionModal?.status}
                    handleClose={handleCloseModal}
                >
                    <h3>{descriptionModal?.title}</h3>
                    <h5>{description}</h5>
                </CustomModal>
            )}
        </div>
    )
}

export default NotificationList